<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-form @submit.prevent="addItem">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-button variant="primary" @click="$router.go(-1)" class="pull-left">Terug</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-card>
                <template slot="header">
                  Nieuwsbericht toevoegen
                </template>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-row>
                      <b-col>
                        <b-form-group label="Titel">
                          <b-form-input type="text" required v-model="item.title"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Preview">
                          <b-form-input type="text" required v-model="item.preview"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Uitgelichte afbeelding">
                          <b-form-file v-model="featuredImageFile" placeholder="Selecteer een bestand..."></b-form-file>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-row>
                      <b-col>
                        <b-form-group label="Uitgelicht">
                          <b-form-checkbox
                            required
                            v-model="item.featured"
                            switch
                            size="md"
                          >
                            {{ item.featured ? 'Ja' : 'Nee' }}
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <template slot="footer">
                    <b-button type="submit" variant="success" class="pull-right" :disabled="saveButtonDisabled">Toevoegen</b-button>
                </template>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
  import { addData } from '../../api';

  export default {
    name: 'news-article',
    data() {
      return {
        saveButtonDisabled: false,
        item: {
          featured: false
        },
        featuredImageFile: null,

      };
    },
    methods: {
      async addItem() {
        this.saveButtonDisabled = true;

        let formData = new FormData();
        Object.keys(this.item).forEach(key => {
            let value = this.item[key];

            if (key === 'featured') {
              value = +value;
            }

            formData.append(key, value);
        });

        const request = await addData('news-articles', formData);

        if (request.status === 201) {
          this.$router.push({ name: 'news-articles.view', params: { id: request.data.data.id } });
        } else {
          this.saveButtonDisabled = false;
        }
      },
    },
    watch: {
      'featuredImageFile'(newValue) {
        this.item.new_featured_image = newValue;
      }
    },
  };
</script>

<style>
.ck-editor__editable_inline {
  min-height: 200px;
}
</style>
